import { Component, Input, ElementRef, ViewChild, forwardRef, OnInit, Injector, inject } from '@angular/core'

import {
  ControlValueAccessor,
  FormsModule,
  ReactiveFormsModule,
  NG_VALUE_ACCESSOR,
  Validators,
  NgControl,
} from '@angular/forms'
import { IconValuesType } from '../icon/icon.component.types'
import { TypographyComponent } from '../typography'
import { ErrorComponent } from '../error'

@Component({
  selector: 'hyperkit-textarea',
  templateUrl: './text-area.component.html',
  styleUrls: ['./text-area.component.scss'],
  standalone: true,
  imports: [
    FormsModule,
    ReactiveFormsModule,
    TypographyComponent,
    ErrorComponent
],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => TextAreaComponent),
      multi: true,
    },
  ],
})
export class TextAreaComponent implements ControlValueAccessor, OnInit {
  private injector = inject(Injector);
  private elementRef = inject(ElementRef);

  @ViewChild('textareaElement')
  textareaElement!: ElementRef<HTMLTextAreaElement>

  @Input() label?: string
  @Input() hint?: string
  @Input() placeholder = ''
  @Input() rightIcon?: IconValuesType
  @Input() showClear = false
  @Input() rows = 3
  @Input() errorMessage = ''
  @Input() hasError = false
  @Input() maxlength?: number

  value = ''
  isFocused = false
  disabled = false
  public ngControl: NgControl | null = null

  private onChange: (value: string) => void = (value: string) => {
    console.warn('onChange function not registered yet.', value)
  }

  private onTouched: () => void = () => {
    console.warn('onTouched function not registered yet.')
  }

  ngOnInit(): void {
    this.ngControl = this.injector.get(NgControl, null)
    if (this.ngControl) {
      this.ngControl.valueAccessor = this
    }
  }

  get isRequired(): boolean {
    return !!this.ngControl?.control?.hasValidator?.(Validators.required)
  }

  onInput(event: Event): void {
    const value = (event.target as HTMLTextAreaElement).value
    this.value = value
    this.onChange(value)
  }

  onCancel(): void {
    if (!this.disabled) {
      this.value = ''
      this.onChange('')
    }
  }

  onFocus(): void {
    this.isFocused = true
    this.onTouched()
  }

  clearText(): void {
    if (!this.disabled) {
      this.value = ''
      this.onChange('')
    }
  }

  onBlur(): void {
    this.isFocused = false
    this.onTouched()
  }

  // ControlValueAccessor implementation
  writeValue(value: string | null): void {
    this.value = value ?? ''
  }
  registerOnChange(fn: (value: string) => void): void {
    this.onChange = fn
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled
  }
}
